import React from "react";
import PropTypes from "prop-types";
import getTime from "date-fns/get_time";
//Limitless imports
import { useAppConfig } from "@limitless/common/hooks";
import { useExpertProfileContext } from "../../../hooks/expert-profile/ExpertProfileContext";
import { validateAboutForm } from "../../../utils/validators/AboutFormValidator";
import { findUserCountry, getUserDob, getUserSocialSecurity } from "../../../utils/AboutFormHelper";
import { getAllDirtyFields } from "../../../utils/FieldValidators";
const AboutForm = ({
  children
}) => {
  const {
    countryList
  } = useAppConfig();
  const {
    profile,
    saveProfile,
    loading
  } = useExpertProfileContext();
  const [firstName, setFirstName] = React.useState({
    value: "",
    pristine: true
  });
  const [lastName, setLastName] = React.useState({
    value: "",
    pristine: true
  });
  const [gender, setGender] = React.useState({
    value: "",
    pristine: true
  });
  const [country, setCountry] = React.useState(findUserCountry(profile, countryList));
  const [socialSecurityNo, setSocialSecurityNo] = React.useState(getUserSocialSecurity(country));
  const [dob, setDob] = React.useState(getUserDob(profile));
  React.useEffect(() => {
    if (countryList.length > 0) {
      setCountry(findUserCountry(profile, countryList));
    }
  }, [countryList]);
  React.useEffect(() => {
    if (country) {
      setSocialSecurityNo(getUserSocialSecurity(country));
    }
  }, [country]);
  React.useEffect(() => {
    if (profile) {
      setFirstName({
        value: profile.firstName || "",
        pristine: false
      });
      setLastName({
        value: profile.lastName || "",
        pristine: false
      });
      setGender({
        value: profile.gender || "",
        pristine: true
      });
    }
  }, [profile]);
  const onFormSubmit = () => {
    saveProfile(getAllDirtyFields({
      firstName: {
        ...firstName,
        value: firstName.value.trim()
      },
      lastName: {
        ...lastName,
        value: lastName.value.trim()
      },
      gender,
      socialSecurityNo,
      dob
    }));
  };
  const handleDOBChange = value => {
    const valueInSeconds = value ? getTime(new Date(value)) : 0;
    setDob({
      formattedValue: value,
      value: valueInSeconds,
      pristine: false
    });
  };
  const {
    fieldErrors,
    isFormInvalid
  } = validateAboutForm({
    firstName,
    lastName,
    gender,
    dob,
    socialSecurityNo
  });
  return children({
    firstName,
    lastName,
    country,
    gender,
    email: profile.email,
    dob,
    socialSecurityNo,
    fieldErrors,
    isFormInvalid,
    onFirstNameChange: value => setFirstName({
      value: value.trim() === "" ? value.trim() : value,
      pristine: false
    }),
    onLastNameChange: value => setLastName({
      value: value.trim() === "" ? value.trim() : value,
      pristine: false
    }),
    onGenderChange: value => setGender({
      value,
      pristine: false
    }),
    onDOBChange: handleDOBChange,
    onSocialSecurityNoChange: value => setSocialSecurityNo({
      ...socialSecurityNo,
      value,
      pristine: false
    }),
    onFormSubmit,
    loading
  });
};
export default AboutForm;
AboutForm.propTypes = {
  children: PropTypes.func.isRequired
};